/**
 * Created by henian.xu on 2019/10/8.
 *
 */
const _localStorage = window.localStorage;
const _sessionStorage = window.sessionStorage;
function getStore(local = true) {
    return local ? _localStorage : _sessionStorage;
}
function set(key: string, value: any, local = true) {
    try {
        value = JSON.stringify(value);
    } catch (e) {
        console.error(e);
    }
    getStore(local).setItem(key, value);
}
function get(key: string, local = true) {
    let value: any | null = getStore(local).getItem(key);
    if (value !== null) {
        try {
            value = JSON.parse(value);
        } catch (e) {
            console.error(e);
        }
    }
    return value;
}
function remove(key: string, local = true) {
    getStore(local).removeItem(key);
}
const localStorage = {
    set: (key: string, value: any) => set(key, value),
    get: (key: string) => get(key),
    remove: (key: string) => remove(key),
};
const sessionStorage = {
    set: (key: string, value: any) => set(key, value, false),
    get: (key: string) => get(key, false),
    remove: (key: string) => remove(key, false),
};
export { localStorage, sessionStorage };
